"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8.412 7.575l2.915-5.907a.75.75 0 011.346 0l2.915 5.907 6.52.953a.75.75 0 01.415 1.28l-4.717 4.594 1.113 6.491a.75.75 0 01-1.088.79L12 18.618l-5.83 3.067a.75.75 0 01-1.09-.79l1.114-6.492-4.717-4.595a.75.75 0 01.415-1.28l6.52-.952zM12 3.695L9.583 8.591a.75.75 0 01-.565.41l-5.407.79 3.912 3.81a.75.75 0 01.216.665l-.923 5.382 4.835-2.543a.75.75 0 01.698 0l4.835 2.543-.923-5.382a.75.75 0 01.216-.664l3.912-3.81-5.407-.79a.75.75 0 01-.565-.411L12 3.694z"
  }));
};

SvgStar.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgStar.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgStar;
exports["default"] = _default;
module.exports = exports.default;